import React from 'react'
import styled from 'styled-components'
import { css } from '@styled-system/css'
import { Container } from 'ui/acro'
import TrialCtaBox from './TrialCtaBox'
import ConnectBanner from './ConnectBanner'
import { Box, Flex } from 'ui/bend'

const img =
  'https://alomoves.s3.amazonaws.com/manual_uploads/shared/home/free_trial/071723_Web_SignedOut_Homepage_2.jpg'

const ParallaxBox = styled(Box)(() =>
  css({
    backgroundImage: [`url(${img})`, `url(${img})`],
    position: ['static', 'absolute', 'absolute', 'absolute'],
    top: '0',
    left: '0',
    width: '100%',
    height: ['360px', '100%'],
    backgroundSize: 'cover',
    backgroundAttachment: ['scroll', 'fixed'],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    zIndex: ['auto', '-1']
  })
)

const ContainerBox = styled(Container)(() =>
  css({
    marginLeft: '5%'
  })
)
const TrialConnectHub = ({ cta, id, body, title, onClickBtn1, ...rest }) => {
  return (
    <Flex
      flexDirection={'column'}
      style={{ position: 'relative' }}
      mt={['80px', '100px']}
      mb={['-90px', '-110px']}
    >
      <ParallaxBox />
      <ContainerBox>
        <TrialCtaBox
          cta={cta}
          body={body}
          title={title}
          onClickBtn={onClickBtn1}
        />
      </ContainerBox>
      <ConnectBanner />
    </Flex>
  )
}

export default TrialConnectHub
